export default [
  {
    path: "/",
    name: "homePage",
    meta: {
      title: "首页",
    },
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      title: "关于允朗",
    },
    component: () => import("@/views/about/index.vue"),
  },
  {
    path: "/invest",
    name: "invest",
    meta: {
      title: "投资理念",
    },
    component: () => import("@/views/invest/index.vue"),
  },
  {
    path: "/news",
    name: "newsIndex",
    meta: {
      title: "新闻资讯",
    },
    component: () => import("@/views/news/index.vue"),
    children: [
      {
        path: "home",
        name: "newsHome",
        meta: {
          title: "新闻首页",
        },
        component: () => import("@/views/news/home.vue"),
      },
      {
        path: "list",
        name: "newsList",
        meta: {
          title: "新闻列表",
        },
        component: () => import("@/views/news/list.vue"),
      },
      {
        path: "details",
        name: "newsDetails",
        meta: {
          title: "新闻详情",
        },
        component: () => import("@/views/news/details.vue"),
      },
    ],
  },
  {
    path: "/search",
    name: "newsSearchPage",
    meta: {
      title: "搜索内容",
    },
    component: () => import("@/views/news/searchPage.vue"),
  },
  {
    path: "/contactUs",
    name: "contactUs",
    meta: {
      title: "联系我们",
    },
    component: () => import("@/views/contactUs/index.vue"),
  },
  {
    path: "/qrPage",
    name: "qrPage",
    meta: {
      title: "联系我们",
    },
    component: () => import("@/views/qrPage.vue"),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error/404.vue'),
  },
  {
    path: '*',
    redirect: '/404'
  }
];
